<template>
  <div class='mainPage'>
    <headBar headbartype="normal"></headBar>
    <mainBody></mainBody>
    <dialogSchedule></dialogSchedule>
    <dialogProject></dialogProject>
    <dialogMember></dialogMember>
  </div>
</template>

<script>
import headBar from './component/headBar.vue'
import mainBody from './component/mainBody.vue'
import dialogSchedule from '../others/dialogSchedule.vue'
import dialogProject from '../others/dialogProject.vue'
import dialogMember from '../others/dialogMember.vue'
import moment from 'moment'

// import axios from 'axios'
export default {
  name: 'mainPage',
  components: {
    headBar,
    mainBody,
    dialogSchedule,
    dialogProject,
    dialogMember
  },
  data: function () {
    return {
      userInfo: {
        name: '',
        member_num: ''
      }
    }
  },
  methods: {
  },
  created () {
    this.$store.dispatch('setSelectDate', moment().format('YYYY-MM-DD'))
    this.$store.dispatch('setTodayScheduleList')
    // this.$store.dispatch('setAllScheduleList')
    this.$store.dispatch('setProjectList')
    this.$store.dispatch('setCategoryList')
    this.$store.dispatch('setRemindTimeList')
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/mainPage.vue